import { AutoComplete, Select } from "antd"
import { getContestDetail } from "api/contest"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

const XhwxSchool = ({ value, onChange }: { value?: string, onChange?: (val: string) => void }) => {

    const id = useParams()?.id

    const [list, setList] = useState<{ label: string, value: string }[]>([])

    useEffect(() => {
        if (!id) return
        getContestDetail({ id: Number(id) }).then(res => {
            const contestJSON = JSON.parse(res?.pageCfg || "{}")
            setList(contestJSON.school)
        })
    }, [id])
    return <div>
        <AutoComplete
            showSearch
            placeholder="请选择所在学校"
            value={value}
            onSearch={(e) => onChange && onChange(e)}
            onChange={(e) => onChange && onChange(e)}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={list}
        />
    </div>
}

export default XhwxSchool